module.exports = __webpack_public_path__ + "img/744.82999841.jpg";